<template>
  <div id="app">
    <v-app id="inspire">
      <v-navigation-drawer
        v-if="pageData.utente.isLogged && pageData.utente.isAdmin"
        v-model="drawer"
        :mini-variant="mini"
        :permanent="!isMobile"
        style="max-height: 100%; z-index: 5;"
        class="secondary"
        mini-variant-width="45"
        width="180"
        fixed
        app
      >
        <v-list class="pt-0 ">
          <v-list-tile
            v-for="item in items"
            :key="item.url"
            :href="item.url"
            class="drawer-item"
            color="primarytext"
          >
            <v-list-tile-action>
              <v-tooltip
                :disabled="mini === false"
                right
                open-delay="10"
                close-delay="10"
              >
                <v-icon
                  slot="activator"
                  color="primarytext"
                >{{ item.icon }}</v-icon>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="primarytext--text">{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider light />
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        v-if="pageData.utente.isLogged"
        color="primary"
        fixed
        app
      >
        <v-toolbar-side-icon
          v-if="pageData.utente.isAdmin"
          @click.stop="toggleMenu"
        />
        <v-toolbar-title class="light-blue--text text--darken-4">{{ pageData.pageTitle }}</v-toolbar-title>
        <v-spacer />
        <v-img
          :src="pageData.baseURL + 'template/accueil/images/accueil.png'"
          height="44"
          class="logo-wrap"
          contain
          aspect-ratio="1.7"
        />
        <v-spacer />
        <!--<v-tooltip bottom>-->
        <!--<template v-slot:activator="{ on }">-->
        <v-icon @click="downloadWithVueResource">get_app</v-icon>
        <!--</template>-->
        <span>Manuale utente</span>
        <!--</v-tooltip>-->
        <v-toolbar-items>
          <v-menu
            bottom
            left
            transition="scale-transition"
          >
            <v-btn
              slot="activator"
              flat
              icon
            >
              <v-icon>more_vert</v-icon>
            </v-btn>

            <v-list>
              <v-dialog
                v-if="pageData.utente.login === '16LGA'"
                width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-list-tile v-on="on">
                    <v-list-tile-title>Cambia utente</v-list-tile-title>
                  </v-list-tile>
                </template>

                <v-card>
                  <v-form
                    :action="pageData.baseURL + 're-login'"
                    method="post"
                  >
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                    >
                      Cambia utente
                    </v-card-title>

                    <v-card-text>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Login</label>
                          <input
                            name="user"
                            type="text"
                            class="form-control"
                            placeholder="Login di nuovo utente"
                          >
                          <i class="form-group__bar" />
                        </div>
                      </div>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="tree"
                        flat
                        type="submit"
                      >
                        Cambia
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
              <v-list-tile :href="pageData.baseURL + 'logout'">
                <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>

      <component :is="componentName" />

      <notifications
        group="success"
        position="top right"
      >
        <template
          slot="body"
          slot-scope="props"
        >
          <v-alert
            :value="true"
            type="success"
          >
            <div v-html="props.item.text" />
          </v-alert>
        </template>
      </notifications>
      <notifications
        group="error"
        position="bottom right"
      >
        <template
          slot="body"
          slot-scope="props"
        >
          <v-alert
            :value="true"
            type="error"
          >
            <div v-html="props.item.text" />
          </v-alert>
        </template>
      </notifications>
      <notifications
        group="warning"
        position="bottom right"
      >
        <template
          slot="body"
          slot-scope="props"
        >
          <v-alert
            :value="true"
            type="warning"
          >
            <div v-html="props.item.text" />
          </v-alert>
        </template>
      </notifications>
      <DevIndicatore v-if="pageData.appData.produzione == 'false'" />
      <loading
        :show="$store.state.loading"
        label="Caricamento..."
      />
    </v-app>
  </div>
</template>
<script>
import * as components from '../../../imports'
import DevIndicatore from '../components/DevIndicatore.vue';
import Loading from '../components/Loading.vue';
import store from './store';

export default {
  name: "App",
  data () {
    return {
      drawer: null,
      mini: true,
      right: null,
      url: "template/accueil/images/manuale_utente.pdf?" + Date.now(),
      isMobile: false
    }
  },
  store,
  computed: {
    items () {
      return this.$store.getters.getPageData.menu;
    },
    pageData () {
      return this.$store.getters.getPageData;
    }
  },
  created () {
    this.isMobile = this.$vuetify.breakpoint.width < 960
    this.$moment.locale('it', {
      months: 'Gennaio_Febbraio_Marzo_Aprile_Maggio_Giugno_Luglio_Agosto_Settembre_Ottobre_Novembre_Dicembre'.split('_'),
      weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_')
    })
    this.$store.commit('SET_PAGE_DATA', JSON.parse(this.componentProperty));
  },
  components: {
    ...components,
    DevIndicatore,
    Loading
  },
  props: {
    componentName: { type: String, required: true },
    componentProperty: { type: String, required: false },
  },
  methods: {
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'manuale_utente_rimborsi.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    },

    downloadWithVueResource () {

      this.$http({
        method: 'get',
        url: this.url,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))

    },
    toggleMenu () {
      if (this.isMobile) {
        this.drawer = !this.drawer
      } else {
        this.mini = !this.mini
      }
    }
  }
}
</script>

<style lang="less">
@import "../../../node_modules/sweetalert2/dist/sweetalert2.css";
@import "../../../node_modules/element-ui/lib/theme-chalk/scrollbar.css";
@import "../../../node_modules/vuetify/dist/vuetify.min.css";

html {
  overflow: auto;
}

.full-heigth {
  height: 100vh;
}
.has-danger:after {
  content: "x";
}
.drawer-item > .v-list__tile.v-list__tile--link:hover {
  background: rgba(0, 0, 0, 0.22);
}
.v-navigation-drawer--mini-variant .drawer-item > a {
  padding: 0;
}
.sidebar-scroll__wrapper {
  overflow-x: hidden !important;
}
.sidebar-scroll__wrapper .el-scrollbar__bar.is-horizontal {
  display: none;
}
.swal2-popup {
  border-radius: 0;
  .swal2-input {
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// template/accueil/js/App.vue